
export default {
  hero: {
    badge: 'Cơ Hội Hợp Tác',
    title: 'Trở Thành Đối Tác Của Chúng Tôi',
    subtitle: 'Cùng The Daeg International Trade - Xây Dựng Sự Nghiệp Thành Công',
    description: 'Chúng tôi đang tìm kiếm các đối tác chiến lược để mở rộng mạng lưới kinh doanh tại Châu Á và Châu Âu. Hãy cùng chúng tôi tạo ra giá trị bền vững và phát triển cùng nhau.',
    stats: {
      commission: { value: 'Ưu Đãi', label: 'Hoa Hồng' },
      support: { value: '100%', label: 'Hỗ Trợ' },
      experience: { value: '5+', label: 'Năm Kinh Nghiệm' },
    },
    ctaPrimary: 'Đăng Ký Hợp Tác Ngay',
    ctaSecondary: 'Tìm Hiểu Quyền Lợi',
  },
  intro: {
    title: 'Cơ Hội Hợp Tác',
    heading: 'Mở Rộng Dịch Vụ, Tăng Doanh Thu Cùng The Daeg',
    description1: 'The Daeg International Trade đang tìm kiếm các đối tác chiến lược để mở rộng mạng lưới kinh doanh tại Châu Á và Châu Âu. Với hơn 5 năm kinh nghiệm trong lĩnh vực xuất nhập khẩu và đầu tư quốc tế, chúng tôi đã xây dựng được nền tảng vững chắc và sẵn sàng chia sẻ thành công với các đối tác.',
    description2: 'Chúng tôi cung cấp cơ hội hợp tác hấp dẫn với lợi ích rõ ràng, hỗ trợ chuyên nghiệp và tiềm năng phát triển bền vững.',
    badge: 'Kinh nghiệm',
    badgeValue: '5+ Năm',
  },
  benefits: {
    title: 'Lợi Ích Khi Hợp Tác',
    badge: 'Quyền Lợi',
    subtitle: 'Chúng tôi cam kết mang đến giá trị thực sự cho đối tác với chính sách hỗ trợ toàn diện',
    items: [
      { title: 'Hoa Hồng Hấp Dẫn', description: 'Nhận hoa hồng cạnh tranh từ mỗi giao dịch thành công' },
      { title: 'Hỗ Trợ Chuyên Nghiệp', description: 'Được hỗ trợ toàn diện từ đội ngũ chuyên gia của chúng tôi' },
      { title: 'Sản Phẩm Chất Lượng', description: 'Tiếp cận các sản phẩm và dịch vụ chất lượng từ The Daeg' },
      { title: 'Đào Tạo & Phát Triển', description: 'Chương trình đào tạo định kỳ để nâng cao kỹ năng chuyên môn' },
      { title: 'Hỗ Trợ Marketing', description: 'Tài liệu marketing và công cụ hỗ trợ bán hàng được cung cấp' },
      { title: 'Hợp Tác Dài Hạn', description: 'Xây dựng mối quan hệ đối tác bền vững, cùng nhau phát triển' },
    ],
  },
  target: {
    title: 'Chúng Tôi Đang Tìm Kiếm',
    badge: 'Đối Tượng',
    subtitle: 'Chúng tôi hoan nghênh hợp tác với các đơn vị và cá nhân có cùng tầm nhìn phát triển',
    items: [
      { title: 'Tư Vấn Di Trú', description: 'Các tư vấn viên có kinh nghiệm trong lĩnh vực di trú và đầu tư quốc tế' },
      { title: 'Môi Giới Bất Động Sản', description: 'Các môi giới bất động sản có mạng lưới khách hàng rộng' },
      { title: 'Tư Vấn Tài Chính', description: 'Các chuyên gia tài chính có hiểu biết về đầu tư quốc tế' },
      { title: 'Tổ Chức Kinh Doanh', description: 'Các tổ chức, doanh nghiệp muốn mở rộng dịch vụ' },
    ],
  },
  whyPartner: {
    title: 'Tại Sao Hợp Tác Với Chúng Tôi',
    badge: 'Điểm Mạnh',
    subtitle: 'Những lý do khiến chương trình đầu tư định cư Latvia qua The Daeg trở thành lựa chọn hàng đầu',
    items: [
      { title: 'Thương Hiệu Uy Tín', description: 'The Daeg International Trade - Thương hiệu đáng tin cậy với 5+ năm kinh nghiệm' },
      { title: 'Doanh Nghiệp Thực', description: 'Sở hữu chuỗi siêu thị Asian Alley với doanh thu ổn định' },
      { title: 'Tỷ Lệ Thành Công Cao', description: 'Tỷ lệ thành công 98% trong các hồ sơ định cư Latvia' },
      { title: 'Quy Trình Chuyên Nghiệp', description: 'Quy trình rõ ràng, minh bạch với đội ngũ pháp lý hỗ trợ' },
      { title: 'Mức Đầu Tư Hợp Lý', description: 'Mức đầu tư từ €50,000 — thấp hơn nhiều so với các chương trình Golden Visa tại Bồ Đào Nha, Hy Lạp hay Tây Ban Nha.' },
      { title: 'Thẻ Tạm Trú Châu Âu', description: 'Nhà đầu tư nhận Thẻ Tạm Trú Latvia, tự do đi lại 27 quốc gia Schengen, mở ra cánh cửa châu Âu cho cả gia đình.' },
      { title: 'Xử Lý Nhanh', description: 'Quy trình xét duyệt nhanh chóng, thường chỉ từ 2-4 tháng. Không cần chờ đợi lâu như các chương trình khác.' },
      { title: 'Tiềm Năng Tăng Trưởng', description: 'Thị trường thực phẩm châu Á tại Baltic đang tăng trưởng mạnh. Nhà đầu tư không chỉ có thẻ cư trú mà còn có lợi nhuận từ kinh doanh.' },
    ],
  },
  process: {
    title: 'Quy Trình Hợp Tác',
    badge: 'Quy Trình',
    heading: 'Bắt Đầu Hợp Tác Chỉ Với 4 Bước',
    subtitle: 'Quy trình đơn giản, nhanh chóng để trở thành đối tác chính thức của The Daeg',
    steps: [
      { title: 'Đăng Ký Quan Tâm', description: 'Điền form đăng ký hợp tác' },
      { title: 'Gặp Gỡ Trao Đổi', description: 'Gặp gỡ để trao đổi về cơ hội hợp tác' },
      { title: 'Ký Kết Hợp Đồng', description: 'Ký kết hợp đồng hợp tác' },
      { title: 'Đào Tạo', description: 'Tham gia chương trình đào tạo' },
      { title: 'Bắt Đầu Hợp Tác', description: 'Bắt đầu hoạt động hợp tác' },
    ],
  },
  form: {
    badge: 'Liên Hệ Hợp Tác',
    title: 'Sẵn Sàng Trở Thành Đối Tác?',
    description: 'Điền thông tin bên cạnh để đăng ký hợp tác. Đội ngũ của chúng tôi sẽ liên hệ trong vòng 24 giờ để trao đổi chi tiết về chương trình.',
    formTitle: 'Đăng Ký Hợp Tác',
    contact: {
      hotlineLabel: 'Hotline Hợp Tác',
      emailLabel: 'Email Hợp Tác',
      addressLabel: 'Trụ Sở Chính',
    },
    commitment: {
      badge: 'Cam Kết Của Chúng Tôi',
      quote: '"Chúng tôi không chỉ tìm kiếm đối tác kinh doanh, mà tìm kiếm những người đồng hành cùng tầm nhìn — xây dựng cầu nối giữa Việt Nam và châu Âu, mang đến cơ hội thực sự cho mỗi gia đình."',
    },
    labels: {
      companyName: 'Tên Công Ty / Tổ Chức',
      contactPerson: 'Người Liên Hệ',
      phone: 'Số Điện Thoại',
      email: 'Email',
      website: 'Website',
      experience: 'Kinh Nghiệm Định Cư',
      message: 'Lời Nhắn',
    },
    placeholders: {
      companyName: 'Nhập tên công ty',
      contactPerson: 'Họ và tên',
      phone: 'Số điện thoại',
      email: 'Email liên hệ',
      website: 'https://...',
      experience: 'Chọn kinh nghiệm',
      message: 'Chia sẻ thêm về đơn vị của bạn (tối đa 500 ký tự)',
    },
    experienceOptions: ['Dưới 1 năm', '1 - 3 năm', '3 - 5 năm', 'Trên 5 năm'],
    required: '*',
    charCount: 'ký tự',
    submit: 'Gửi Đăng Ký Hợp Tác',
    submitting: 'Đang gửi...',
    success: 'Đăng ký hợp tác thành công! Chúng tôi sẽ liên hệ với bạn trong vòng 24 giờ.',
    error: 'Có lỗi xảy ra. Vui lòng thử lại sau.',
  },
} as const;
